import { Action, createReducer, on } from '@ngrx/store';

import * as builtInInsightsActions from '@live/actions/live-builtIn-insights.actions';

import IBuiltInInsight = Microsoft.VideoIndexer.Live.Contracts.IBuiltInInsight;

export interface IState {
  loaded: boolean;
  isLoading: boolean;
  error: boolean;
  builtInInsights: IBuiltInInsight[];
}

export const initialState: IState = {
  loaded: false,
  isLoading: false,
  error: false,
  builtInInsights: []
};

const liveBuiltInInsightsReducer = createReducer(
  initialState,
  on(builtInInsightsActions.loadBuiltInInsightsSuccess, (state, { builtInInsights }) => {
    return {
      ...state,
      error: false,
      loaded: true,
      isLoading: false,
      builtInInsights
    };
  }),
  on(builtInInsightsActions.loadBuiltInInsightsInProgress, state => {
    return {
      ...state,
      isLoading: true,
      loaded: false
    };
  }),
  on(builtInInsightsActions.loadBuiltInInsightsFailed, state => {
    return {
      ...state,
      error: true,
      loaded: true,
      isLoading: false,
      builtInInsights: []
    };
  })
);

export function reducer(state: IState | undefined, action: Action) {
  return liveBuiltInInsightsReducer(state, action);
}
